<ul class="second-level" role="menu" [attr.aria-label]="parentLabel">
  @for (item of menuItems; track item) {
    @if (!item.isHidden) {
      <li
        role="none"
        [class.active]="item.isActive$ | async"
        [class.disabled]="item.isDisabled"
        [class.tw:inline-flex]="item.isDisabled"
        [class.tw:items-center]="item.isDisabled"
      >
        <a
          class="nav-item tw:flex tw:items-center"
          role="menuitem"
          [attr.aria-current]="item.isActive$ | async"
          [attr.href]="item.href"
          [class.disabled-state]="item.isDisabled"
          (click)="onMenuItemClick($event, item)"
        >
          <ng-container [ngTemplateOutlet]="item.content" />
          @if (item.isExternalLink()) {
            <ga-icon class="tw:ml-2" [icon]="icons.ExternalLink" />
          }
        </a>
        @if (item.isDisabled) {
          <ga-icon [gaTooltip]="item.tooltipText" [icon]="icons.Info" />
        }
      </li>
    }
  }
</ul>
